export default __webpack_public_path__ + "static/char-s-18-chs-58790a282bd7e9e7ab86b8f3f60ca6f8.webp";